import { render, staticRenderFns } from "./yunpuManage.vue?vue&type=template&id=0a52750b&scoped=true&"
import script from "./yunpuManage.vue?vue&type=script&lang=js&"
export * from "./yunpuManage.vue?vue&type=script&lang=js&"
import style0 from "./yunpuManage.vue?vue&type=style&index=0&id=0a52750b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a52750b",
  null
  
)

export default component.exports